import { type ReactNode, useEffect } from "react";
import { XIcon } from "./fields";

/** Right-hand editor panel. Esc closes. */
export function Drawer({
  title,
  chip,
  onClose,
  children,
  footer,
}: {
  title: string;
  chip?: ReactNode;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <>
      <button type="button" className="scrim" aria-label="Close editor" onClick={onClose} />
      <aside className="drawer" role="dialog" aria-modal="true" aria-label={title}>
        <header className="drawer-head">
          {chip}
          <h2 className="drawer-title">{title}</h2>
          <button type="button" className="close-x" aria-label="Close" onClick={onClose}>
            <XIcon />
          </button>
        </header>
        <div className="drawer-body">{children}</div>
        {footer && <footer className="drawer-foot">{footer}</footer>}
      </aside>
    </>
  );
}
